export const BOT_RULES = {
  maxBots: 3,
} as const;
